import { createMuiTheme } from '@material-ui/core/styles';
import { rgba } from '@zeals/shared-utils';

export default createMuiTheme({
  palette: {
    type: 'light',
    error: {
      main: '#E5004B',
    },
    primary: {
      main: '#1739A5',
      light: '#0057B8',
    },
    secondary: {
      main: '#1EC18D',
    },
  },
  spacing: [2, 4, 8, 16, 32, 64, 128, 256, 512, 1024, 2048],
  typography: {
    fontFamily: 'Noto Sans JP',
    button: {
      fontWeight: 800,
      fontSize: 14,
    },
    h6: {
      fontWeight: 'bold',
    },
    subtitle1: {
      fontWeight: 'bold',
    },
    subtitle2: {
      color: rgba('#000', 0.2),
      fontSize: '0.75em',
      fontWeight: 'bold',
    },
  },
});
